<i class="bi bi-box-arrow-up-right fw-bold me-2"></i>
